import React from "react";

function Footer() {
  return (
    <div>
      <div className='mb-0'>
        <div className='brand-bg1 pt-10'>
          <div className='container'>
            <div className='row py-10 py-lg-20'>
              <div className='col-lg-5 pe-lg-16 mb-10 mb-lg-0'>
                <div className='rounded landing-dark-border p-9 mb-10'>
                  <h2 className='text-white'>
                    8th Floor, UBA House, Marina, Lagos
                  </h2>

                  <span className='fw-normal fs-4 text-gray-300 mb-4'>
                    Email us
                    <br />
                    <p className='text-white'>Info@3rdretailafrica.com</p>
                  </span>

                  <span className='fw-normal fs-4 text-gray-300'>
                    Call us
                    <br />
                    <p className='text-white'>+234 8037 127 155</p>
                  </span>
                </div>
              </div>

              <div className='col-lg-6 ps-lg-16'>
                <div className='d-flex justify-content-center'>
                  <div className='d-flex fw-bold flex-column me-20'>
                    <h4 className='fw-bolder text-gray-400 mb-6'>Links</h4>

                    <a
                      href='www.3rdretail.com'
                      className='text-white opacity-50 text-hover-primary fs-5 mb-6'
                    >
                      About
                    </a>

                    <a
                      href='www.3rdretail.com'
                      className='text-white opacity-50 text-hover-primary fs-5 mb-6'
                    >
                      Contact
                    </a>

                    <a
                      href='www.3rdretail.com'
                      className='text-white opacity-50 text-hover-primary fs-5 mb-6'
                    >
                      FAQ
                    </a>
                  </div>

                  <div className='col-lg-6 ps-lg-16'>
                    <div className='d-flex justify-content-center'>
                      <div className='d-flex fw-bold flex-column me-20'>
                        <h4 className='fw-bolder text-gray-400 mb-6'>Others</h4>

                        <a
                          href='www.3rdretail.com'
                          className='text-white opacity-50 text-hover-primary fs-5 mb-6'
                        >
                          Terms of Use
                        </a>

                        <a
                          href='www.3rdretail.com'
                          className='text-white opacity-50 text-hover-primary fs-5 mb-6'
                        >
                          Privacy Policy
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* <div className='d-flex col-lg-4 fw-bold flex-column ps-lg-20 me-20'>
                    <h4 className='fw-bolder text-gray-400 mb-6'>Socials</h4>

                    <a href='#' className='mb-6'>
                      <img
                        src='assets/media/svg/brand-logos/facebook-4.svg'
                        className='h-20px me-2'
                        alt=''
                      />
                      <span className='text-white opacity-50 text-hover-primary fs-5 mb-6'>
                        Facebook
                      </span>
                    </a>

                    <a href='#' className='mb-6'>
                      <img
                        src='assets/media/svg/brand-logos/twitter.svg'
                        className='h-20px me-2'
                        alt=''
                      />
                      <span className='text-white opacity-50 text-hover-primary fs-5 mb-6'>
                        Twitter
                      </span>
                    </a>

                    <a href='#' className='mb-6'>
                      <img
                        src='assets/media/svg/brand-logos/instagram-2-1.svg'
                        className='h-20px me-2'
                        alt=''
                      />
                      <span className='text-white opacity-50 text-hover-primary fs-5 mb-6'>
                        Instagram
                      </span>
                    </a>
                  </div> */}
                </div>
              </div>
            </div>

            <div className='landing-dark-separator'></div>

            <div className='container'>
              <div className='d-flex flex-column flex-md-row flex-stack py-7 py-lg-10'>
                <div className='d-flex align-items-center order-2 order-md-1'>
                  <a href='www.3rdretail.com'>
                    <img
                      alt='Logo'
                      src='./assets/media/logos/3rdretaillogoblue.svg'
                      className='h-15px h-md-20px'
                    />
                  </a>

                  <span
                    className='mx-5 fs-6 fw-bold text-gray-600 pt-1'
                    href='www.3rdretail.com'
                  >
                    © 2022 3rdretail Africa.
                  </span>
                </div>

                <div className='d-flex col-lg-4 fw-bold flex-roll ps-lg-20 me-20'>
                  <a href='https://facebook.com/3rdretail' className='mb-6'>
                    <img
                      src='assets/media/svg/brand-logos/facebook-4.svg'
                      className='h-20px me-2'
                      alt=''
                    />
                    <span className='text-white opacity-50 text-hover-primary fs-5 mb-6 me-3'>
                      Facebook
                    </span>
                  </a>

                  <a href='https://3rdretail.com' className='mb-6'>
                    <img
                      src='assets/media/svg/brand-logos/twitter.svg'
                      className='h-20px me-2'
                      alt=''
                    />
                    <span className='text-white opacity-50 text-hover-primary fs-5 mb-6 me-3'>
                      Twitter
                    </span>
                  </a>

                  <a href='https://instagram.com/3rdretail' className='mb-6 '>
                    <img
                      src='assets/media/svg/brand-logos/instagram-2-1.svg'
                      className='h-20px me-2'
                      alt=''
                    />
                    <span className='text-white opacity-50 text-hover-primary fs-5 mb-6'>
                      Instagram
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
